import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import HttpService from '../services/httpService';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import decorpotLogo from "../assets/img/org/decorpot_new_logo.png";
import '../App.css'
import { SpecificUserCategory } from '../utils/index';

const ServiceIvrsForm = (props) => {
    const history = useHistory();
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        location: '',
        projectId: '',
        existingTicket: '',
        issueDetails: ''
    });
    const [specificUserDetails, setSpecificUserDetails] = useState([]);
    const [toggleForm, setToggleForm] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Allow only letters, spaces, hyphens, and apostrophes in the 'name' field
        if (name === 'name' && !/^[a-zA-Z\s'-]*$/.test(value)) {
            return;
        }
    
        // Allow only numbers in the 'mobile' field
        if (name === 'mobile' && !/^\d*$/.test(value)) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validateForm = () => {
        const { name, mobile, email, location, projectId, issueDetails } = formData;
        if (!name || !mobile || !email || !location || !projectId || !issueDetails) {
            props.setSnackInfo('All fields are required except Existing Ticket!', 'error');
            return false;
        }
        if (name.trim().length < 3 || location.trim().length < 3 || projectId.trim().length < 3 || issueDetails.trim().length < 3) {
            props.setSnackInfo('Details Should more than 3 Letter', 'error');
            return false;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailRegex.test(email)) {
            props.setSnackInfo('Please enter a valid email address', 'error');
            return false;
        }
        const phoneRegex = /^[0-9]{10}$/;
        if (!mobile || !phoneRegex.test(mobile)) {
            props.setSnackInfo('Phone number should be exactly 10 digits', 'error');
            return false;
        }
        if (!captchaValue) {
            props.setSnackInfo('Please complete the CAPTCHA', 'error');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const { departmentId, teamId, _id, name, email } = specificUserDetails[0] || {};

        const dataToSend = {
            assignedDepartment: departmentId,
            assignedTeam: teamId,
            email: email,
            category: SpecificUserCategory.serviceCategory,
            assignedTo: { _id, name, email },
            status: 'Pending',
            otherProjectDetails: formData
        };

        try {
            props.setLoading(true);
            const response = await HttpService.submitIssueForm(dataToSend);
            props.setSnackInfo('Form Submitted Successfully', 'success');
            localStorage.setItem('formFilledForService', JSON.stringify(true)); // Set form status in localStorage
            history.push('/thank-you');
        } catch (error) {
            props.setSnackInfo('Something Went Wrong', 'error');
        } finally {
            props.setLoading(false);
        }
    };

    const getUserDetails = async () => {
        try {
            const res = await HttpService.getUserForWhatsAppMessage();
            setSpecificUserDetails(res.data['Support']);
        } catch (error) {
            props.setSnackInfo('Failed to fetch user details', 'error');
        }
    };

    useEffect(() => {
        getUserDetails();
    }, []);

    useEffect(() => {
        const isFormFilled = JSON.parse(localStorage.getItem('formFilledForService')); // Get formFilled from localStorage
        if (isFormFilled) {
            history.push('/thank-you'); // Redirect to Thank You page if form is already filled
        }
    }, [toggleForm]);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
            <Box
                component="form"
                onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 600,
                    width: '80%',
                    padding: '16px',
                    gap: '16px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    backgroundColor: 'white'
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <img
                        src={decorpotLogo}
                        alt="decorpot logo"
                        style={{ width: "50%", textAlign: "center" }}
                    />
                </div>
                <Typography variant="h6" align="center">Issue Reporting Form</Typography>

                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Registered Mobile Number"
                    name="mobile"
                    value={formData.mobile}
                    type="tel"
                    onChange={handleChange}
                    fullWidth
                    required
                    inputProps={{ maxLength: 10 }}
                    helperText="Mobile number must be exactly 10 digits"
                />
                <TextField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="email"
                    fullWidth
                    required
                />
                <TextField
                    label="Location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Project ID"
                    name="projectId"
                    value={formData.projectId}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Existing Ticket (Optional)"
                    name="existingTicket"
                    value={formData.existingTicket}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Please Provide Details of the Issue"
                    name="issueDetails"
                    value={formData.issueDetails}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    fullWidth
                    required
                />
                
                <div className="recaptcha-container">
                    <ReCAPTCHA
                        sitekey="6Le9u30qAAAAAPctnNdH11nMpOBjbl5uJPCeLJAj"
                        onChange={handleCaptchaChange}
                    />
                </div>

                <Button type="submit" variant="contained" color="primary" fullWidth disabled={!captchaValue}>
                    Submit
                </Button>
            </Box>
        </Box>
    );
};

export default connect(null, { setLoading, setSnackInfo })(ServiceIvrsForm);